import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ArticleState {
    stockStatus: string | null;
    isWaitingStockStatus: boolean;
}

const initialState: ArticleState = {
    stockStatus: null,
    isWaitingStockStatus: false,
};

const articleSlice = createSlice({
    name: 'article',
    initialState,
    reducers: {        
        setIsWaitingStockStatus: (state, action: PayloadAction<boolean>) => {
            state.isWaitingStockStatus = action.payload;
        },
        setStockStatus: (state, action: PayloadAction<string | null>) => {
            state.stockStatus = action.payload;
        },
    },
});

export const {
    setIsWaitingStockStatus,
    setStockStatus,
} = articleSlice.actions;

export default articleSlice.reducer;